(function($) {
    $.fn.focusTrap = function() {
            if(this.keydownEvent){
                $(this).unbind(this.keydownEvent);
            }
            focusElements = $(this).find('a[href], button, textarea, aside[tabindex="0"], input[type="text"], input[type="radio"], input[type="checkbox"], select').filter(':visible:not([disabled])');
            if(focusElements.length > 0){
                var firstFocusElement = focusElements[0];
                firstFocusElement.focus();
                var lastFocusElement = focusElements[focusElements.length - 1];
                var KEYCODE_TAB = 9;
                $(this).keydown(function(e){
                    this.keydownEvent = e;
                    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
                    if(isTabPressed){
                        if ( e.shiftKey ){
                            if (document.activeElement === firstFocusElement) {
                                lastFocusElement.focus();
                                e.preventDefault();
                            }
                        } else {
                            if (document.activeElement === lastFocusElement) {
                                firstFocusElement.focus();
                                e.preventDefault();
                            }
                        }
                    }
                });
            }
        return this;
    };
    $.fn.removeFocusTrap = function() {
        $(this).unbind(this.keydownEvent);
    };
}( jQuery ));